/**
 * @file 通用的工具函数
 */

import {ObserverOptions, LogParams} from '../types/utils';

/**
 * 监听元素是否进入视口
 *
 * @param el 目标元素
 * @param callback 当元素变为可视时执行的回调函数
 * @param threshold 元素可见度阈值，默认为1，表示元素必须完全可见时才会触发回调
 */
export const handleObserver = (options: ObserverOptions): IntersectionObserver | null => {
    try {
        const {el, threshold = 1, callback} = options;
        if (!el || !IntersectionObserver) {
            return null;
        }
        const observer = new IntersectionObserver(
            entries => {
                try {
                    entries.forEach(entry => {
                        if (entry.intersectionRatio >= threshold) {
                            callback?.();
                        }
                    });
                }
                catch (err) {
                    console.error('IntersectionObserver: 回调执行出错', err);
                    return null;
                }
            },
            {threshold}
        );
        observer.observe(el);
        return observer;
    }
    catch (err) {
        console.error('IntersectionObserver: 初始化失败', err);
        return null;
    }
};

/**
 * 防抖函数
 *
 * @param func 需要防抖的函数。
 * @param delay 防抖延迟时间（毫秒）。
 * @returns 返回一个新的函数，该函数在延迟时间内若被再次调用，则重新计时。
 */
export const debounce = <T extends (...args: any[]) => any>(
    func: T,
    delay: number
) => {
    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    return function (this: any, ...args: Parameters<T>) {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => func.apply(this, args), delay);
    };
};

// 打点
export const handleLog = (options: LogParams) => {
    const {category, action, label, value} = options;
    window?._hmt?.push(['_trackEvent', category, action, label, value]);
};
